import { SwitchProductModule } from '@wix/package-picker-sdk';
import { useCurrentModule } from '../../components/ModuleProvider';
import { useAnonymous } from '../useAnonymous';
export const useValidateProductId = () => {
  const module = useCurrentModule();
  const {
    isAnonymous
  } = useAnonymous();
  const selectedProductId = module.SDK.PackagePickerStore.useSelectedProductId();
  const {
    canPurchase,
    isLoading: isProductAvailabilityLoading
  } = SwitchProductModule.SDK.hooks.useProductAvailability({
    productId: selectedProductId || ''
  });
  return {
    // TODO - this need to be change to if we are in downgrade or switch or upgrade then check canPuchase, or put this logic inside the switch module
    valid: isAnonymous || canPurchase,
    isLoading: isProductAvailabilityLoading
  };
};
//# sourceMappingURL=useValidateProductId.js.map